import {
  GET_ECONOMICNUMBERS_CATALOG,
  GET_ECONOMICNUMBERS_CATALOG_SUCCESS,
  GET_ECONOMICNUMBERS_CATALOG_ERROR,
} from '../../../../constants/constantsRed';

export const getEconomicNumbersCatalogRed = (
  state: any,
  actions: any
) => {
  switch (actions.type) {
    case GET_ECONOMICNUMBERS_CATALOG:
      return {
        ...state,
        loading: true,
      };
    case GET_ECONOMICNUMBERS_CATALOG_ERROR:
      return {
        data: null,
        loading: false,
        error: null,
      };
    case GET_ECONOMICNUMBERS_CATALOG_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        data: actions.payload,
      };
    default:
      return state;
  }
};
